import { useQuery } from '@tanstack/react-query';

import getV1StockOdtOrderHistorytradefilterById from '@services/api/stock/history/dtDetail';

/**
 * @param {import('@services/api/stock/history/dtDetail').DtHistoryDetailParams}  objectParams
 */
function useHistoryDtDetail({ idxNo, startDate }) {
  const { cb, key } = getV1StockOdtOrderHistorytradefilterById({ idxNo, startDate });

  const { data, isSuccess, isLoading } = useQuery(key, cb, {
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });

  return { data, isSuccess, isLoading };
}

export default useHistoryDtDetail;
